import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

type MonthSelectProps = {
    title?: string;
    isOptional?: boolean;
    placeholder?: string;
    form?: string;
    errorMessage?: string;
    isDisabled?: boolean;
    defaultValue?: number;
    onChange: (endMonth: number[]) => void;
    size?: 'small' | 'standard';
};

function MonthSelect({
    title,
    isOptional = false,
    placeholder,
    form,
    errorMessage,
    isDisabled,
    onChange,
    defaultValue,
    size = 'standard',
}: MonthSelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    function handleEndMonthChange(options: SelectV2Option[]): void {
        if (JSON.stringify(options) === JSON.stringify(selected)) {
            return;
        }
        onChange(options.map((o) => o.value as number));
    }

    useEffect(() => {
        setSelected(defaultValue ? [{ label: months[defaultValue - 1], value: defaultValue }] : []);
    }, [defaultValue]);

    return (
        <div>
            <SelectV2
                keepSelectedOptions
                placeholder={placeholder || 'Select a month...'}
                title={title}
                form={form}
                isOptional={isOptional}
                disabled={isDisabled}
                size={size}
                errorMessage={errorMessage}
                value={selected}
                onSearch={setSearch}
                onChange={handleEndMonthChange}
                options={months
                    .filter((month) => month.toLowerCase().includes(search.toLowerCase()))
                    .map((m) => ({
                        label: m,
                        value: months.indexOf(m) + 1,
                    }))}
            />
        </div>
    );
}
export default MonthSelect;
